
<template>
  <v-footer padless id="kontakt">
    <v-container>
      <!-- Nagłówek -->
      <v-row>
        <v-col>
          <v-card flat>
            <v-card-title class="justify-center">Kontakt</v-card-title>
          </v-card>
        </v-col>
      </v-row>

      <!-- Sekcja 1: Informacje o firmie (Nazwa, Adres, NIP, Regon) -->
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="3"
          v-for="(item, i) in companyInfo"
          :key="i"
        >
          <v-list height="100%">
            <v-subheader class="justify-center">{{ item.name }}</v-subheader>

            <v-list-item @click="copyText(item.text)" link>
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-tooltip right nudge-left="100" :key="i" color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content v-bind="attrs" v-on="on">
                    <v-list-item-title class="text-wrap" v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <span>Skopiuj</span>
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      
      <!-- Sekcja 2: Kontakty (Handlowy, Biuro, Techniczny) - PRZYWRÓCONA -->
      <v-row>
        <!-- Dział Handlowy -->
        <v-col cols="12" md="4">
          <v-list height="100%">
            <v-subheader class="justify-center">Dział handlowy — Paweł Pękul</v-subheader>
            <v-list-item
              v-for="(contact, i) in contacts.dzaial_handlowy"
              :key="i"
              :href="
                !isMobile
                  ? ''
                  : contact.type == 'mail'
                  ? `mailto:${contact.text}`
                  : `tel:${contact.text}`
              "
              @click="copyText(contact.text)"
            >
              <v-list-item-icon>
                <v-icon v-text="contact.icon"></v-icon>
              </v-list-item-icon>
              <v-tooltip right nudge-left="100" :key="i" color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content v-bind="attrs" v-on="on">
                    <v-list-item-title class="text-wrap" v-text="contact.text"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <span>Skopiuj</span>
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-col>

        <!-- Biuro -->
        <v-col cols="12" md="4">
          <v-list height="100%">
            <v-subheader class="justify-center">Biuro</v-subheader>
            <v-list-item
              v-for="(contact, i) in contacts.biuro"
              :key="i"
              :href="
                !isMobile
                  ? ''
                  : contact.type == 'mail'
                  ? `mailto:${contact.text}`
                  : `tel:${contact.text}`
              "
              @click="copyText(contact.text)"
            >
              <v-list-item-icon>
                <v-icon v-text="contact.icon"></v-icon>
              </v-list-item-icon>
              <v-tooltip right nudge-left="100" :key="i" color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content v-bind="attrs" v-on="on">
                    <v-list-item-title class="text-wrap" v-text="contact.text"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <span>Skopiuj</span>
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-col>

        <!-- Dział Techniczny -->
        <v-col cols="12" md="4">
          <v-list height="100%">
            <v-subheader class="justify-center">Dział techniczny — Kamil Szydlik</v-subheader>
            <v-list-item
              v-for="(contact, i) in contacts.dzaial_techniczny"
              :key="i"
              :href="
                !isMobile
                  ? ''
                  : contact.type == 'mail'
                  ? `mailto:${contact.text}`
                  : `tel:${contact.text}`
              "
              @click="copyText(contact.text)"
            >
              <v-list-item-icon>
                <v-icon v-text="contact.icon"></v-icon>
              </v-list-item-icon>
              <v-tooltip right nudge-left="100" :key="i" color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content v-bind="attrs" v-on="on">
                    <v-list-item-title class="text-wrap" v-text="contact.text"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <span>Skopiuj</span>
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>

    <div id="my_div" class="designed">
      — Created by <strong>CoreStudio</strong> —
    </div>

    <v-snackbar color="success" v-model="snackbar" :timeout="3000">
      <v-icon class="mr-2">mdi-check</v-icon>
      Wartość <strong>{{ copyValue }}</strong> została zapisana w schowku!

      <template v-slot:action="{ attrs }">
        <v-btn
          small
          elevation="0"
          fab
          dark
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      copyValue: "",
      snackbar: false,
      contacts: {
        biuro: [
          {
            text: "biuro@jkpelektromontaz.pl",
            icon: "mdi-email",
            type: "mail",
          },
        ],
        dzaial_handlowy: [
          {
            text: "pawel.pekul@jkpelektromontaz.pl",
            icon: "mdi-email",
            type: "mail",
          },
          {
            text: "501 765 882",
            icon: "mdi-phone",
            type: "phone",
          },
        ],
        dzaial_techniczny: [
          {
            text: "kamil.szydlik@jkpelektromontaz.pl",
            icon: "mdi-email",
            type: "mail",
          },
          {
            text: "506 972 803",
            icon: "mdi-phone",
            type: "phone",
          },
        ],
      },
      companyInfo: [
        {
          name: "Nazwa firmy",
          // Użyto \u00A0 (twarda spacja)
          text: "JKP Elektromontaż sp.\u00A0z\u00A0o.o.",
          icon: "mdi-office-building",
        },
        {
          name: "Adres firmy",
          text: "Nowy Brańszczyk 28/B, 07-221 Brańszczyk",
          icon: "mdi-map-marker",
        },
        {
          name: "NIP",
          text: "7622023931",
          icon: "mdi-clipboard-text",
        },
                {
          name: "Regon",
          text: "540697632",
          icon: "mdi-clipboard-text",
        },
      ],
    };
  },
  methods: {
    copyText(textToCopy) {
      const tmpTextField = document.createElement("textarea");
      tmpTextField.textContent = textToCopy;
      tmpTextField.setAttribute("style", "position:absolute; right:200%;");
      document.body.appendChild(tmpTextField);
      tmpTextField.select();
      tmpTextField.setSelectionRange(0, 99999); /*For mobile devices*/
      document.execCommand("copy");
      tmpTextField.remove();
      this.copyValue = textToCopy;
      this.snackbar = true;
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
};
</script>

<style lang="scss">
.designed {
  background: #000;
  color: #fff;
  font-size: 0.8rem;
  flex: 0 0 100%;
  padding: 5px 0;
  text-align: center;
}
</style>